import React, { useEffect, useState } from 'react';
import categoriasRepository from '../../repositories/categoria';

import PageDefault from '../../components/PageDefault';
import BannerMain from '../../components/BannerMain';
import Carousel from '../../components/Carousel';

const Home = () => {

  const [dadosIniciais, setDadosIniciais] = useState([]);

  useEffect(() => {
    categoriasRepository.getAllWithVideos()
      .then((categorias) => {
        setDadosIniciais(categorias);
      }).catch(err => console.log(err.message));
  }, []);

  return (
    <PageDefault>
      {dadosIniciais.map((categoria, indice) => {
        if (indice === 0) {
          return (
            <div key={ categoria.id }>
              <BannerMain
                videoTitle={ dadosIniciais[0].videos[0].titulo }
                url={ dadosIniciais[0].videos[0].url }
                videoDescription={ dadosIniciais[0].videos[0].description }
              />

              <Carousel
                ignoreFirstVideo
                category={ dadosIniciais[0] }
              />    
            </div>
          )
        }

        return (
          <Carousel
            key={ categoria.id }
            ignoreFirstVideo
            category={ categoria }
          />
        )
      })}
    </PageDefault>
  );
}

export default Home;
